import React, { useState, useEffect } from 'react';
import moment from 'moment';

import GoodStuffComponent from '../../components/goodStuff';
import { useAppDispatch } from '../../hooks/reduxHooks';
import { getReferralHistoryApi } from '../../services/referral.service';
import PageLoader from '../../components/common/loader/pageLoader';

interface GoodStuffContainerInterface {

}

const GoodStuffContainer: React.FC<GoodStuffContainerInterface> = () => {
  const dispatch = useAppDispatch()
  const [loadingHistory, setLoadingHistory] = useState(true);
  const [historyData, setHistoryData] = useState([]);

  useEffect(() => {
    fetchHistory()
  }, [])

  const tableColumn = [
    {
      title: "History",
      dataIndex: "detail",
      key: "detail",
      render: (status?: any, data?: any) => {
        return (
          <>
            {data?.status === 'referred' ? `Referred to ${data?.user?.name ?? 'others'}` : `Claimed discount (Referred by: ${data?.referrer?.name})`} {data?.user_status === 'claiming' ? "(Claiming)" : ""}
          </>
        )
      }
    },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (created_at?: any) => {
        return <>{moment(created_at).format("MMMM Do, YYYY")}</>;
      },
    },
    {
      title: "Reward",
      dataIndex: "points_earned",
      key: "points_earned",
      render: (points_earned?: any, data?: any) => {
        return (
          <>
            {points_earned}
          </>
        )
      }
    },
  ];

  const fetchHistory = () => {
    dispatch(getReferralHistoryApi({
      successCallback: (data?: any) => {
        setHistoryData(data?.data)
      },
      finalCallback: () => {
        setLoadingHistory(false)
      }
    }))
  }

  if (loadingHistory) {
    return (
      <PageLoader />
    )
  }

  return (
    <GoodStuffComponent
      loadingHistory={loadingHistory}
      historyData={historyData}
      tableColumn={tableColumn}
    />
  )
}

export default GoodStuffContainer;
